<template>
  <div class="container-fluid py-5">
    <div class="row justify-content-center">
      <div class="col-lg-6 text-center">
        <div class="py-5">
          <i class="bi bi-exclamation-triangle fs-1 text-warning mb-4"></i>
          <h1 class="display-1 fw-bold text-primary">404</h1>
          <h2 class="h4 mb-3">Página no encontrada</h2>
          <p class="text-muted mb-4">
            La página que buscas no existe o ha sido movida.
          </p>
          <router-link to="/" class="btn btn-primary">
            <i class="bi bi-house me-2"></i>
            Ir al inicio
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotFound'
}
</script>
